<template lang="html">
  <div v-if="loading" class="page-loader">
    <p>Loading<span>.</span><span>.</span><span>.</span></p>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
  }),
  methods: {
    start() {
      this.loading = true;
    },
    finish() {
      setTimeout(() => {
        this.loading = false;
      }, 200);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.page-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  color: $red;
  padding: 2rem;
  font-size: 3rem;
  z-index: 9999;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  @keyframes blinking {
    from {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }

  span {
    font-size: 2em;
    animation: blinking 0.6s linear 0s infinite alternate;

    @for $i from 1 through 3 {
      &:nth-child(#{$i}) {
        animation-delay: #{($i - 1) * 0.2s};
      }
    }
  }
}
</style>
